import {
  YEAR_CHANGE,
  DATAVIEW_CHANGE,
  CHARACTERISTIC_TOGGLE,
  TABLE_COLUMN_ORDER_CHANGE,
} from 'Config/types';
import actionTrigger from './';

export function actionTriggerWithIndicator(type, indicator, data) {
  return actionTrigger(type, { indicator, ...data });
}

export function actionYearChange(indicator, year, mega = false) {
  return actionTriggerWithIndicator(
    YEAR_CHANGE,
    indicator,
    { year, ...(false !== mega) ? { mega } : {} }
  );
}

export function actionTableColumnOrderChanged(columnState) {
  return actionTrigger(TABLE_COLUMN_ORDER_CHANGE, { columnState });
}

export function actionDataViewChange(indicator, dataView, mega = false) {
  return actionTriggerWithIndicator(
    DATAVIEW_CHANGE,
    indicator,
    { dataView, ...(false !== mega) ? { mega } : {} }
  );
}

export function actionCharacteristicToggle(row) {
  return actionTrigger(CHARACTERISTIC_TOGGLE, { row });
}

export const curry = (fn) => (first) => (...second) => fn(first, ...second);

const actionsWithIndicator = (indicator) => ({
  actionYearChange: curry(actionYearChange)(indicator),
  actionDataViewChange: curry(actionDataViewChange)(indicator),
});

export default actionsWithIndicator;



// WEBPACK FOOTER //
// ./app/actions/table.js